/**
 * Purchase Protection checkbox component
 *
 * Part of the send (F&F) and buy (G&S) flows to reduce F&F abuse.
 * We will automatically check the purchase protection checkbox if the recipient is a merchant,
 * but the action (send/buy) can also be manually changed.
 */

import PropTypes from 'prop-types'

import React from 'react'
import classNames from 'classnames'
import content from 'pp-react-l10n'
let i18n = content('transfer/page/preview')

const STYLES = {
  input: {
    width: 0,
    height: 0,
    position: 'absolute',
    top: 10,
    left: 0,
    zIndex: 1,
  },

  label: {
    margin: 0,
    display: 'table',
    marginBottom: 15,
  },

  checkbox: {
    display: 'table-cell',
    verticalAlign: 'text-top',
  },

  shield: {
    display: 'table-cell',
    verticalAlign: 'text-top',
    fontSize: '24px',
    color: '#009cde',
  },

  text: {
    paddingLeft: '10px',
    display: 'inline-block',
    verticalAlign: 'top',
    textAlign: 'left',
    lineHeight: '20px',
  },
}

class PurchaseProtectionCheckbox extends React.Component {
  // 'send' | 'buy' Tells us whether p2p or Goods flow is loading this component.
  static propTypes = {
    flowType: PropTypes.string.isRequired,
    containerStyle: PropTypes.object,
    isFriendsFamilyEligible: PropTypes.bool.isRequired,
    purchaseProtectionLink: PropTypes.object.isRequired,
    handleChangePurchaseProtection: PropTypes.func.isRequired,
  }

  static defaultProps = {
    purchaseProtectionLink: {
      linkUrl:
        '/webapps/mpp/paypal-safety-and-security#paypal-protects-your-purchase-protection',
    },
  }

  handleChange = e => {
    this.props.handleChangePurchaseProtection(e.target.checked)
  }

  /**
   * Render the purchase protection checkbox
   * User has the option to toggle purchase protection, which toggles F&F and G&S
   */
  renderPurchaseProtectionCheckbox = () => {
    let { flowType, containerStyle = {} } = this.props

    let checked = flowType === 'buy' || flowType === 'payRequest'
    let checkboxClassNames = classNames('icon', {
      'icon-checkmark-small': checked,
    })

    return (
      <div className="ppCheckbox" style={containerStyle}>
        <input
          id="purchaseProtectionCheckbox"
          name="purchaseProtection"
          type="checkbox"
          style={STYLES.input}
          checked={checked}
          onChange={this.handleChange}
        />

        <label htmlFor="purchaseProtectionCheckbox" style={STYLES.label}>
          <span
            className={checkboxClassNames}
            data-nemo="purchase-protection-checkbox"
            aria-hidden="true"
            style={STYLES.checkbox}
          />
          <span style={STYLES.text}>
            <span>
              {i18n.html('label.purchaseProtection', {
                purchaseProtectionLink: this.props.purchaseProtectionLink
                  .linkUrl,
              })}
            </span>
          </span>
        </label>
      </div>
    )
  }

  /**
   * Render the purchase protected info
   * The only option is G&S, so we tell the user their purchase is protected
   */
  renderPurchaseProtected = () => {
    let { containerStyle = {} } = this.props

    return (
      <div style={{ ...STYLES.label, ...containerStyle }}>
        <span className="icon icon-shield" style={STYLES.shield} />
        <span style={STYLES.text}>
          {i18n.html('label.purchaseProtected', {
            purchaseProtectionLink: this.props.purchaseProtectionLink.linkUrl,
          })}
        </span>
      </div>
    )
  }

  render() {
    return (
      <div>
        {this.props.isFriendsFamilyEligible
          ? this.renderPurchaseProtectionCheckbox()
          : this.renderPurchaseProtected()}
      </div>
    )
  }
}

export default PurchaseProtectionCheckbox
